import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { LoadingService } from '../../providers/loading/loading.service';

@Component({
  selector: 'app-loading-screen',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './loading-screen.component.html',
  styleUrls: ['./loading-screen.component.scss'],
})
export class LoadingScreenCompatComponent implements OnInit, OnDestroy {
  loading = false;
  private loadingSubscription: Subscription;

  constructor(private readonly loadingService: LoadingService) { }

  ngOnInit() {
    this.loadingSubscription = this.loadingService.loadingStatus.subscribe((value) => {
      setTimeout(() => {
        this.loading = value;
        if (value) {
          document.body.setAttribute('style', 'overflow-x:hidden');
        } else {
          document.body.removeAttribute('style');
        }
      });
    });
  }

  ngOnDestroy() {
    this.loadingSubscription?.unsubscribe();
  }
}
